import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import iabDarkTheme from "@/data/defaults/dark.theme";
import iabLightTheme from "@/data/defaults/light.theme";

Vue.use(Vuetify)

export default function createVuetify(store) {
  const lightTheme = store?.getters?.lightTheme || iabLightTheme;
  const darkTheme = store?.getters?.darkTheme || iabDarkTheme;

  return new Vuetify({
    icons: {
      iconfont: 'mdi'
    },
    theme: {
      themes: {
        light: lightTheme,
        dark: darkTheme
      },
      options: {
        customProperties: true
      }
    }
  });
}
